<ng-container *ngIf="item">
  <a
    class="nav-item"
    #link
    [class.active]="active$ | async"
    [clickTrackLocation]="item.data.clickTrack"
    (click)="routerLink(item.path)"
    [attr.data-cy]="'bottom-item-' + item.data.id"
  >
    <u-icon
      class="icon"
      [model]="{ type: 'font', value: item.data.icon.value }"
      [pTooltip]="showTitle ? null : item.data.title"
      tooltipPosition="bottom"
      tooltipStyleClass="u-tooltip"
    ></u-icon>
    <p class="title" *ngIf="showTitle">
      {{ item.data.title }}
    </p>
  </a>
</ng-container>
